module.exports = __webpack_public_path__ + "img/icon-print.bec18410.png";